export enum FilterSortTypeEnum {
  START_DATE = 'START_DATE', //startDate
  DISTANCE = 'DISTANCE'
}
